import React, { Component } from "react";
import { connect } from "react-redux";
import {Container, Col, Row, FormGroup, Form, Input, Button, Table, Alert} from 'reactstrap';
import Header from "../share/Header";
import FormUsuarios from "./FormUsuarios";
import * as usuario from "../../actions/usuario";
import Loading from "../share/Loading";

class Usuarios extends Component {

    constructor(props){
        super(props);
        this.state = {
            numero_identificacion: null,
            detalle_usuario: null
        };
        this.search = this.search.bind(this);
        this.detalleUsuario = this.detalleUsuario.bind(this);
    }

    componentDidMount() {
        this.props.getUsuarios(this.state.numero_identificacion);
    }

    search(e){
        e.preventDefault();
        this.props.getUsuarios(this.state.numero_identificacion);
    };

    detalleUsuario(usuario){
        this.setState({detalle_usuario: usuario});
    }

    render(){

        let { list_users, loading_list_users, error_list_users } = this.props;
        let listaUsuarios = [];

        if(!!list_users){
            listaUsuarios = list_users.map((usuario, i) => {
                return (
                    <tr key={i}>
                        <th scope="row">{usuario.numero_identificacion}</th>
                        <td>{usuario.rol.descripcion}</td>
                        <td>
                            <Button onClick={()=>this.detalleUsuario(usuario)}>Ver</Button>
                        </td>
                    </tr>
                );
            });
        }

        return(
            <div>
                <Header/>
                <Container className = 'usuarios'>
                    <Row>
                        <h1 className="tituloGeneral mt-4 mb-4 text-center w-100 font-italic font-weight-bold">Gestión de usuarios</h1>
                    </Row>
                    <Row className="contenedor ml-1 mr-1">
                        <Col className="contenedorBuscador" md={{size: 6, offset: 0}} sm={{size: 10, offset: 1}} xs={{size: 10, offset: 1}}>
                            <Form className="w-100" onSubmit={this.search}>
                                <FormGroup className="form-group mt-4">
                                    <Row>
                                        <Col xs="8" sm="10" md="9">
                                            <Input type="number" name="numero_identificacion" id="numero_identificacion" placeholder="Cédula" value={this.state.numero_identificacion} onChange={e => this.setState({ numero_identificacion: e.target.value })}/>
                                        </Col>
                                        <Col xs="4" sm="2" md="3" className="text-center">
                                            <Button type="submit">Buscar</Button>
                                        </Col>
                                    </Row>
                                    {
                                        (loading_list_users) ?
                                            <Row>
                                                <Loading/>
                                            </Row> :
                                            <Row className="mt-1">
                                                <h2 className="text-center mt-3 mb-4 font-italic w-100">Listado de usuarios</h2>
                                                {
                                                    (!!error_list_users || (!!list_users && list_users.length === 0)) ?
                                                        <Col md={{size: 10, offset: 1}} className="mt-5">
                                                            <Alert color="danger">
                                                                <Container fluid>
                                                                    <h3 className="text-center">No hay resultados hay usuarios que coincidan</h3>
                                                                </Container>
                                                            </Alert>
                                                        </Col> :
                                                        <Col md="12" className="contenedorListado">

                                                            <Table striped>
                                                                <thead>
                                                                <tr>
                                                                    <th>Cédula</th>
                                                                    <th>Rol</th>
                                                                    <th>Ver</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {listaUsuarios}
                                                                </tbody>
                                                            </Table>
                                                        </Col>
                                                }
                                            </Row>
                                    }
                                </FormGroup>
                            </Form>
                        </Col>
                        <Col className="contenedorFormulario" md={{size: 6, offset: 0}} sm={{size: 10, offset: 1}} xs={{size: 10, offset: 1}}>
                            <FormUsuarios listarUsuarios={()=>this.props.getUsuarios(this.state.numero_identificacion)} usuario={this.state.detalle_usuario}/>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        list_users: state.usuario.list_users,
        loading_list_users: state.usuario.loading_list_users,
        error_list_users: state.usuario.error_list_users
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getUsuarios: (numero_identificacion) => {
            return dispatch(usuario.getUsuarios(numero_identificacion));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Usuarios);